import { render, staticRenderFns } from "./Liquidity.vue?vue&type=template&id=76b7a63e&scoped=true&"
import script from "./Liquidity.vue?vue&type=script&lang=ts&"
export * from "./Liquidity.vue?vue&type=script&lang=ts&"
import style0 from "./Liquidity.vue?vue&type=style&index=0&id=76b7a63e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b7a63e",
  null
  
)

export default component.exports